/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { NewUiWorkflowStepFunctionSubscribedEvent } from '../models/new-ui-workflow-step-function-subscribed-event';
import { UiWorkflowStepFunctionSubscribedEvent } from '../models/ui-workflow-step-function-subscribed-event';
import { UiWorkflowStepFunctionSubscribedEventPartial } from '../models/ui-workflow-step-function-subscribed-event-partial';
import { UiWorkflowStepFunctionSubscribedEventWithRelations } from '../models/ui-workflow-step-function-subscribed-event-with-relations';
import { Count as LoopbackCount } from '../models/loopback/count';

@Injectable({
  providedIn: 'root',
})
export class UiWorkflowStepFunctionSubscribedEventControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation uiWorkflowStepFunctionSubscribedEventControllerCount
   */
  static readonly UiWorkflowStepFunctionSubscribedEventControllerCountPath = '/ui-workflow-step-function-subscribed-events/count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `count()` instead.
   *
   * This method doesn't expect any request body.
   */
  count$Response(params?: {
    where?: any;
  }): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, UiWorkflowStepFunctionSubscribedEventControllerService.UiWorkflowStepFunctionSubscribedEventControllerCountPath, 'get');
    if (params) {
      rb.query('where', params.where, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `count$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  count(params?: {
    where?: any;
  }): Observable<LoopbackCount> {

    return this.count$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation uiWorkflowStepFunctionSubscribedEventControllerFindById
   */
  static readonly UiWorkflowStepFunctionSubscribedEventControllerFindByIdPath = '/ui-workflow-step-function-subscribed-events/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById$Response(params: {
    id: string;
    filter?: any;
  }): Observable<StrictHttpResponse<UiWorkflowStepFunctionSubscribedEvent>> {

    const rb = new RequestBuilder(this.rootUrl, UiWorkflowStepFunctionSubscribedEventControllerService.UiWorkflowStepFunctionSubscribedEventControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UiWorkflowStepFunctionSubscribedEvent>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById(params: {
    id: string;
    filter?: any;
  }): Observable<UiWorkflowStepFunctionSubscribedEvent> {

    return this.findById$Response(params).pipe(
      map((r: StrictHttpResponse<UiWorkflowStepFunctionSubscribedEvent>) => r.body as UiWorkflowStepFunctionSubscribedEvent)
    );
  }

  /**
   * Path part for operation uiWorkflowStepFunctionSubscribedEventControllerDeleteById
   */
  static readonly UiWorkflowStepFunctionSubscribedEventControllerDeleteByIdPath = '/ui-workflow-step-function-subscribed-events/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, UiWorkflowStepFunctionSubscribedEventControllerService.UiWorkflowStepFunctionSubscribedEventControllerDeleteByIdPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById(params: {
    id: string;
  }): Observable<any> {

    return this.deleteById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation uiWorkflowStepFunctionSubscribedEventControllerUpdateById
   */
  static readonly UiWorkflowStepFunctionSubscribedEventControllerUpdateByIdPath = '/ui-workflow-step-function-subscribed-events/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById$Response(params: {
    id: string;
    body?: UiWorkflowStepFunctionSubscribedEventPartial
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, UiWorkflowStepFunctionSubscribedEventControllerService.UiWorkflowStepFunctionSubscribedEventControllerUpdateByIdPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById(params: {
    id: string;
    body?: UiWorkflowStepFunctionSubscribedEventPartial
  }): Observable<any> {

    return this.updateById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation uiWorkflowStepFunctionSubscribedEventControllerFind
   */
  static readonly UiWorkflowStepFunctionSubscribedEventControllerFindPath = '/ui-workflow-step-function-subscribed-events';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params?: {
    filter?: any;
  }): Observable<StrictHttpResponse<Array<UiWorkflowStepFunctionSubscribedEventWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, UiWorkflowStepFunctionSubscribedEventControllerService.UiWorkflowStepFunctionSubscribedEventControllerFindPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<UiWorkflowStepFunctionSubscribedEventWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params?: {
    filter?: any;
  }): Observable<Array<UiWorkflowStepFunctionSubscribedEventWithRelations>> {

    return this.find$Response(params).pipe(
      map((r: StrictHttpResponse<Array<UiWorkflowStepFunctionSubscribedEventWithRelations>>) => r.body as Array<UiWorkflowStepFunctionSubscribedEventWithRelations>)
    );
  }

  /**
   * Path part for operation uiWorkflowStepFunctionSubscribedEventControllerCreate
   */
  static readonly UiWorkflowStepFunctionSubscribedEventControllerCreatePath = '/ui-workflow-step-function-subscribed-events';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params?: {
    body?: NewUiWorkflowStepFunctionSubscribedEvent
  }): Observable<StrictHttpResponse<UiWorkflowStepFunctionSubscribedEvent>> {

    const rb = new RequestBuilder(this.rootUrl, UiWorkflowStepFunctionSubscribedEventControllerService.UiWorkflowStepFunctionSubscribedEventControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UiWorkflowStepFunctionSubscribedEvent>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params?: {
    body?: NewUiWorkflowStepFunctionSubscribedEvent
  }): Observable<UiWorkflowStepFunctionSubscribedEvent> {

    return this.create$Response(params).pipe(
      map((r: StrictHttpResponse<UiWorkflowStepFunctionSubscribedEvent>) => r.body as UiWorkflowStepFunctionSubscribedEvent)
    );
  }

}
